import styled from 'styled-components';

export const SwitchSecurityRankDropdownStyles = styled.div`
	width: 1.5rem;
	height: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.25rem;
	transition: background 0.15s ease;

	&:hover {
		background: ${(props) => props.theme.v3.colors.gray[2]};
	}
`;
